export default "__VITE_PUBLIC_ASSET__ed17ea32__"